import * as tslib_1 from "tslib";
import HLabel from "../../../common/components/label.vue";
import { labelText } from "../../../schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let CreateTime = class CreateTime extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], CreateTime.prototype, "control", void 0);
CreateTime = tslib_1.__decorate([
    Component({
        name: 'CreateTime',
        components: {
            HLabel: HLabel
        }
    })
], CreateTime);
export default CreateTime;
